import { MessageCircle } from "lucide-react";
import { buildWhatsAppUrl } from "@/constants/site";
import { TESTIDS } from "@/constants/testIds";

export default function WhatsAppButton() {
  return (
    <a
      href={buildWhatsAppUrl("Olá Visiovet! Estou vindo do site e gostaria de mais informações.")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco pelo WhatsApp"
      data-testid={TESTIDS.ctaWhatsAppFab}
      className="whatsapp-fab fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full px-5 py-4 shadow-2xl animate-wa-pulse transition-transform duration-200 hover:scale-105"
    >
      <MessageCircle className="h-6 w-6" strokeWidth={2.4} />
      <span className="hidden sm:inline font-semibold text-sm">Fale no WhatsApp</span>
    </a>
  );
}
